import React, { useState } from 'react'
import LineChart from '../../components/lineChart/LineChart'
import StackedBarChart from '../../components/stackedBarChart/StackedBarChart'
import { Box, Button, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import StatisticsModal, { DateFilter } from '../../features/statistics/StatisticsModal'
import styles from '../statisticsBox/StatisticsBox.module.css'

interface StatisticsBoxProps {
  titulo: string
  data: any[]
  dataSetsNames: string[]
  tipoChart: string
  stylesText?: string
  stylesHistorial?: string
  styleInfoBox?: string
  dashboard?: boolean
}

const StatisticsBox = (props: StatisticsBoxProps) => {
  const [open, setOpen] = React.useState(false)
  const modalClose = () => setOpen(false)
  const modalOpen = () => setOpen(true)

  const renderChart = (param: string, props: StatisticsBoxProps, date: DateFilter) => {
    switch (param) {
      case 'line':
        return (
          <LineChart
            titulo={props.titulo}
            data={props.data}
            dataSetsNames={props.dataSetsNames}
            filterDate={date}
            eje={false}
            graphicsPoints={0}
          />
        )
      case 'stackedBar':
        return (
          <StackedBarChart
            titulo={props.titulo}
            data={props.data}
            dataSetsNames={props.dataSetsNames}
            filterDate={date}
            eje={false}
          />
        )
    }
  }

  const [date] = useState<DateFilter>({
    startDate: new Date(),
    finishDate: new Date(),
  })

  const { t } = useTranslation()

  return (
    <>
      <Box
        p={3}
        sx={{
          backgroundColor: 'white',
          borderRadius: '32px',
          border: '1px solid var(--green-primary)',
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
        }}
      >
        <Box className={styles.containerStatistics}>
          <Box className={styles.boxHeader}>
            <h3 className={props.stylesText ? props.stylesText : styles.chartBoxTitle}>
              {props.titulo}
            </h3>
            <Button
              variant="text"
              onClick={modalOpen}
              className={props.stylesHistorial ? props.stylesHistorial : styles.StatsHistory}
            >
              {t('history')}
            </Button>
          </Box>
          <Typography
            color={'green'}
            variant={'h5'}
            className={props.styleInfoBox ? props.styleInfoBox : styles.chartBoxInfo}
          >
            {props.tipoChart == 'stackedBar'
              ? `${
                  props.data[props.data.length - 1]?.very_active
                    ? props.data[props.data.length - 1]?.very_active
                    : 0
                } Minutos muy activos`
              : props.dataSetsNames[0] == 'Sleep'
              ? `${
                  props.data[props.data.length - 1]?.value
                    ? Math.trunc(props.data[props.data.length - 1]?.value / 60)
                    : 0
                } horas y ${
                  props.data[props.data.length - 1]?.value
                    ? props.data[props.data.length - 1]?.value % 60
                    : 0
                } minutos de sueño`
              : `${
                  props.data[props.data.length - 1]?.value
                    ? props.data[props.data.length - 1]?.value
                    : 0
                } ${props.titulo.substring(0, props.titulo.length - 6)}`}
          </Typography>
        </Box>
        <Box className={styles.boxCharts}>{renderChart(props.tipoChart, props, date)}</Box>
      </Box>

      <StatisticsModal hookOpen={open} changeState={modalClose} eventProps={props} />
    </>
  )
}

export default StatisticsBox
